module.exports = __webpack_public_path__ + "img/nhanh-sangtao-camket.266d550e.png";